import React from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
const ShowOwnerDetail = (props) => {
  return (
    <>
      <Modal
        show={props.show}
        onHide={props.handleClose}
        id="playermoreinfo"
        size="lg"
      >
        <Modal.Header>{props.teamName}</Modal.Header>
        <Modal.Body> {ReactHtmlParser(props.ownerDetail)}</Modal.Body>
        <Modal.Footer>
          <div className="poweredby">
            Powered By
            <img src="/images/logo.png" alt="img" />
          </div>
          <div className="">
            <Link className="border-btn" onClick={props.handleClose}>
              Close
            </Link>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ShowOwnerDetail;
